// Generates an audible alert (no sound file needed) plus a phone vibration
// for when a session timer runs out. Browsers block audio until a user has
// interacted with the page, so `unlockAudioContext()` should be called from
// a click handler (e.g. "Start Round") to prime it ahead of time — by the
// time the timer actually hits zero, playback then works without a fresh
// gesture.
var sharedCtx = null;

export function unlockAudioContext() {
  var AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextClass) return;
  if (!sharedCtx) sharedCtx = new AudioContextClass();
  if (sharedCtx.state === "suspended") sharedCtx.resume();
}

export function playTimerAlert() {
  var AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (AudioContextClass) {
    if (!sharedCtx) sharedCtx = new AudioContextClass();
    if (sharedCtx.state === "suspended") sharedCtx.resume();

    var ctx = sharedCtx;
    var now = ctx.currentTime;
    [0, 0.3, 0.6].forEach(function (offset) {
      var osc = ctx.createOscillator();
      var gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = 880;
      gain.gain.setValueAtTime(0, now + offset);
      gain.gain.linearRampToValueAtTime(0.35, now + offset + 0.02);
      gain.gain.linearRampToValueAtTime(0, now + offset + 0.22);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + offset);
      osc.stop(now + offset + 0.25);
    });
  }

  if (navigator.vibrate) navigator.vibrate([250, 120, 250, 120, 250]);
}
